import { PickingListRecordRowShape, PickingListRowShape } from '../../api/api_data_types'

export default function mergePickingListRecords(
  current: PickingListRowShape[] = [],
  records: PickingListRecordRowShape[],
): PickingListRowShape[] {
  const rows: PickingListRowShape[] = []
  const nestedItems = new Set<string>()

  current.forEach((row) => {
    if (row.row_type !== 'calculation') return

    const saved = records.filter((record) => record.item_no === row.item_no)
    nestedItems.add(row.item_no)
    rows.push({
      ...row,
      submitted: saved.length > 0,
      submitted_quantity: saved.reduce((sum, record) => sum + record.quantity, 0),
    })
    rows.push(...saved.map((record) => ({ ...record, nested: true })))
  })

  rows.push(...records.filter((record) => !nestedItems.has(record.item_no)).map((record) => ({ ...record, nested: false })))
  return rows
}
